export default __webpack_public_path__ + "static/media/logo3.bb5e4883.svg";